
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.172 6.938c0-.323-.037-.555-.11-.696-.067-.14-.174-.21-.32-.21a.813.813 0 00-.375.1c-.13.069-.294.183-.492.345L.57 6.016c.36-.297.662-.506.907-.625.25-.125.51-.188.78-.188.423 0 .738.13.946.39.208.256.313.667.313 1.235V8.86c0 .532.122.94.367 1.227.245.286.594.43 1.047.43.74 0 1.27-.399 1.593-1.196.329-.802.51-2.013.547-3.633-.99-.005-1.815-.145-2.476-.421-.657-.276-1.136-.646-1.438-1.11a2.854 2.854 0 01-.453-1.593c0-.521.112-.972.336-1.352.23-.38.54-.667.93-.86.39-.192.83-.288 1.32-.288.703 0 1.294.197 1.774.593.479.39.838.974 1.078 1.75.244.776.367 1.716.367 2.82 0 1.172-.146 2.212-.438 3.118-.286.9-.705 1.59-1.258 2.07-.546.48-1.19.719-1.93.719-.9 0-1.577-.2-2.03-.602-.454-.406-.68-1.01-.68-1.812V6.938zM7.07 5.063c-.01-1.51-.153-2.618-.43-3.32C6.366 1.032 5.936.68 5.353.68c-.448 0-.78.159-.993.476-.208.318-.312.782-.312 1.39 0 .876.242 1.514.726 1.915.49.401 1.256.601 2.297.601z","fill":"currentColor"}})])
          )
        }
      }
    